import styled from '@emotion/styled';
import {PrsStatus} from "core/const/PrsStatus";

export const Label = styled.div<{ status: PrsStatus }>`
  display: inline-flex;
  padding: 4px 12px;
  border-radius: 16px;
  align-items: center;

  ${({ status }) => {
    switch (status) {
      case PrsStatus.Cancelled:
        return `
          background: #FFBAB840;
          color: #AB0033;
        `;
      case PrsStatus.Unpaid:
        return `
          background: #FFE30040;
          color: #675404;
        `;
      case PrsStatus.Ongoing:
        return `
          background: #97DAFF40;
          color: #005CB9;
          `;
      default:
        return `
          background: #C0DF8840;
          color: #00953B;
        `;
    }
  }}
`;
